import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import {
	Card,
	CardContent,
	CardHeader, Collapse,
	Container,
	FormControl,
	Grid,
	InputLabel, MenuItem,
	Paper, Select,
	TextField
} from "@mui/material";
import HideAppBar from "../../widgets/header/HideAppBar";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import clsx from "clsx";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import TamponiDrawer from "../tamponi/drawer/TamponiDrawer";
import useTamponiSearch from "./utils/useTamponiSearch";
import useGetAllRapidi from "./utils/useGetAllRapidi";
import TamponeCard from "../tamponi/details/TamponeCard";
import {AUTOMATION_INITIAL_STATE, AutomationReducer, initAutomationState} from "../../../reducers/AutomationReducer";
import {getAccountInfo} from "../../../utils/GenericUtils";
import {setOpenSnackbar} from "../../../services/AppServices";
import {AppContext} from "../../../App";
import {useHistory} from "react-router-dom";
import FilterListTwoToneIcon from "@mui/icons-material/FilterListTwoTone";
import {onClickDetails} from "../../../services/AutomationServices";


const GestioneRapidi = () => {
	const classes = BaseStyle();
	const contattaciClasses = ContattaciStyle();
	let history = useHistory();
	const appContext = useContext(AppContext);
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const [stato, setStato] = useState("Da gestire");
	const [testTipoDesc, setTestTipoDesc] = useState("Tampone Rapido a lettura facilitata (91.13.S)");
	const [value, setValue] = useState("");
	const [filters, setFilters] = useState("");
	const [pageNumber, setPageNumber] = useState(0);
	const [selected, setSelected] = useState("");
	const [sort, setSort] = useState("dataEsito");
	const [dir, setDir] = useState("ASC");
	const [irreperibili, setIrreperibili] = useState(false);
	const [open, setOpen] = useState(false);
	const {loadingSearch, errorSearch, hasMoreSearch, rapidiSearch} = useTamponiSearch(value, pageNumber)
	const {
		loading,
		error,
		hasMore,
		tamponi,
		info
	} = useGetAllRapidi(stato, filters, pageNumber, testTipoDesc, sort, dir, irreperibili);
	const observer = useRef();
	
	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPageNumber(prevState => prevState + 1);
			}
			if (entries[0].isIntersecting && hasMoreSearch) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore, hasMoreSearch])
	
	const setMenuSelected = useCallback((newValue) => {
		setPageNumber(0);
		setStato(newValue);
	}, []);
	
	const onClickTampone = useCallback((rapido) => {
		setSelected(rapido);
		onClickDetails(rapido.id, "tampone", "modify", automationDispatch);
	}, [automationDispatch])
	
	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				history.push("/gestione/interviste/" + selected.id);
			} else {
				setOpenSnackbar("warning", ("Il tampone è al momento gestito da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected, history, appContext.dispatch])
	
	useEffect(() => {
		setPageNumber(0)
	}, [filters])
	
	useEffect(() => {
		document.body.style = `background: none;`;
	}, []);
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Tamponi rapidi"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Paper className={clsx(classes.filterSearchPaper, classes.roundBorder)} component={"section"}>
								<TextField
									placeholder={"Cerca per Codice fiscale, esito e molto altro"}
									value={value}
									onChange={(e) => setValue(e.target.value)}
									autoFocus={false}
									fullWidth={true}
									variant={"outlined"}
									InputProps={{
										startAdornment: <InputAdornment position="start">
											<Tooltip title={"Cerca"}>
												<IconButton color="inherit" size="large">
													<SearchTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										endAdornment: <InputAdornment position="start">
											<Tooltip title={"Ricerca avanzata"}>
												<IconButton
                                                    color="inherit"
                                                    onClick={() => setOpen(!open)}
                                                    className={clsx(classes.expand, {
                                                        [classes.expandOpen]: open,
                                                    })}
                                                    size="large">
													<FilterListTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										classes: {notchedOutline: contattaciClasses.noBorder}
									}}
								/>
								<Collapse in={open} timeout="auto" unmountOnExit>
									<Grid container spacing={3} className={classes.padding2}>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="sort">Ordina per</InputLabel>
												<Select
													labelId="sort"
													id="sort"
													value={sort}
													onChange={(e) => setSort(e.target.value)}
													label="Ordina per"
												>
													<MenuItem value={"dataEsito"}>Data esito</MenuItem>
													<MenuItem value={"dataCreazione"}>Data creazione</MenuItem>
													<MenuItem value={"dataPrelievoEffettiva"}>Data prelievo effettiva</MenuItem>
													<MenuItem value={"dataPrelievoPrevista"}>Data prelievo prevista</MenuItem>
													<MenuItem value={"dataPrimaModifica"}>Data prima modifica</MenuItem>
													<MenuItem value={"dataUltimaModifica"}>Data ultima modifica</MenuItem>
													<MenuItem value={"indirizzoAssociato"}>Indirizzo associato</MenuItem>
													<MenuItem value={"laboratorio"}>Laboratorio</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="dir">Ascendente / Discendente</InputLabel>
												<Select
													labelId="dir"
													id="dir"
													value={dir}
													onChange={(e) => setDir(e.target.value)}
													label="Ascendente / Discendente"
												>
													<MenuItem value={"ASC"}>Dal più piccolo al più grande</MenuItem>
													<MenuItem value={"DESC"}>Dal più grande al più piccolo</MenuItem>
												</Select>
											</FormControl>
										</Grid>
									</Grid>
								</Collapse>
							</Paper>
						</Grid>
						
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1, display: "flex"}}>
									
									<TamponiDrawer selectMenuItem={setMenuSelected} stato={stato} setFilters={setFilters}
									               filters={filters} rapidi={true} setTestTipoDesc={setTestTipoDesc}
									               testTipoDesc={testTipoDesc} info={info} irreperibili={irreperibili}
									               setIrreperibili={setIrreperibili}/>
									
									<div className={classes.content} style={{maxHeight: 870}}>
										{
											(value === "" ? tamponi : rapidiSearch).map((tampone, index) => {
												if (tamponi.length === index + 1) {
													return (
														<Card ref={lastTicketElementRef} key={tampone.id}
														      className={clsx(classes.roundBorder, classes.mailCard)}>
															<TamponeCard tampone={tampone} setValue={setValue} onClickTampone={onClickTampone}/>
														</Card>
													)
												} else {
													return (
														<Card key={tampone.id} className={clsx(classes.roundBorder, classes.mailCard)}>
															<TamponeCard tampone={tampone} setValue={setValue} onClickTampone={onClickTampone}/>
														</Card>
													)
												}
											})
										}
										{value === "" && !loading && !error && tamponi.length === 0 &&
											<Alert severity="info" style={{borderRadius: 24}}>
												<AlertTitle>Evvai 😇!!</AlertTitle>
												Non ci sono tamponi! Goditi questo meritato relax
											</Alert>}
										{value === "" && loading &&
											<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
												<CardHeader
													avatar={<Skeleton variant="circular" height={40} width={40}/>}
													title={<Skeleton width={180}/>}
													subheader={<Skeleton width={260}/>}
													action={<Skeleton variant="circular" height={20} width={20}/>}
													style={{paddingBottom: 2}}
												/>
												<CardContent style={{paddingTop: 0, marginTop: -35}}>
													<Skeleton height={200}/>
												</CardContent>
											</Card>}
										{value === "" && error && !loading && <Alert severity="error" style={{borderRadius: 24}}>
											<AlertTitle>Errore</AlertTitle>
											Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
											sviluppatori.
										</Alert>}
										
										{value !== "" && !loadingSearch && rapidiSearch.length === 0 &&
											<Alert severity="info" style={{borderRadius: 24}}>
												<AlertTitle>Evvai 😇!!</AlertTitle>
												Non ci sono tamponi! Goditi questo meritato relax
											</Alert>}
										{value !== "" && loadingSearch &&
											<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
												<CardHeader
													avatar={<Skeleton variant="circular" height={40} width={40}/>}
													title={<Skeleton width={180}/>}
													subheader={<Skeleton width={260}/>}
													action={<Skeleton variant="circular" height={20} width={20}/>}
													style={{paddingBottom: 2}}
												/>
												<CardContent style={{paddingTop: 0, marginTop: -35}}>
													<Skeleton height={200}/>
												</CardContent>
											</Card>}
										{value !== "" && errorSearch && !loadingSearch &&
											<Alert severity="error" style={{borderRadius: 24}}>
												<AlertTitle>Errore ricerca</AlertTitle>
												Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
												sviluppatori.
											</Alert>}
									</div>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
        </React.Fragment>
    );
};

export default React.memo(GestioneRapidi);
